import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import fr from 'vuetify/es5/locale/fr'
import { getVuetifyTheme } from '@agrial/ui'

Vue.use(Vuetify)

export default new Vuetify({
  breakpoint: {
    mobileBreakpoint: 960
  },
  theme: Object.assign(getVuetifyTheme('agricoleOMCerealesSemences'), {
    themes: {
      light: {
        primaryLighten1: '#b2b543',
        primary: '#969A27',
        primaryDarken1: '#7a8001',
        secondary: '#006E33',
        accent: '#eb6608',
        info: '#9E9FA2',
        succes: '#00D06C',
        error: '#FD3050',
        warning: '#FF9800'
      }
    }
  }),
  lang: {
    locales: { fr },
    current: 'fr'
  }
})
